import { axiosMeedioClient } from './client';
import { MeetingInvitation } from './types';

export const getMeetingInvitations = async (meetingId: string): Promise<MeetingInvitation[]> => {
  const { data } = await axiosMeedioClient.get<MeetingInvitation[]>(`/meetings/${meetingId}/invitations`);
  return data;
};
